// @flow
import React, { type Node } from 'react';
import styled from 'styled-components';

import { mergeClassNames } from 'utils/functions';

const StyledButtonGroup = styled.div`
    button.btn {
        box-shadow: none !important;
        margin: 0 !important;
        &:active,
        &:focus {
            box-shadow: none !important;
            outline: none !important;
        }
        &:not(:last-child) {
            border-right-width: 1px !important;
        }
        &.btn-light:not(:last-child) {
            border-right-color: ${props => props.theme.color.secondary} !important;
        }
    }
`;

type ButtonGroupProps = {
    /** will be appended to the classes */
    className?: string,
    /** what will be rendered inside the button */
    children: Node,
};

export const ButtonGroup = (props: ButtonGroupProps) => {
    const { className = '', children, ...domProps } = props;
    return (
        <StyledButtonGroup
            className={mergeClassNames('btn-group', className)}
            {...domProps}
        >
            {children}
        </StyledButtonGroup>
    );
};

export default ButtonGroup;
